import { render, staticRenderFns } from "./taxIncomeWagesList.vue?vue&type=template&id=18ecd02e&scoped=true&"
import script from "./taxIncomeWagesList.vue?vue&type=script&lang=js&"
export * from "./taxIncomeWagesList.vue?vue&type=script&lang=js&"
import style0 from "./taxIncomeWagesList.vue?vue&type=style&index=0&id=18ecd02e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ecd02e",
  null
  
)

export default component.exports